import React, { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import {
  TextField,
  Paper,
  Grid,
  Avatar,
  Button,
  Divider,
  Container,
  Typography,
  Stack,
  useTheme,
  CircularProgress,
} from "@mui/material";
import { Dialog, DialogContent, DialogActions, Drawer } from "@mui/material";

import { format, parseISO } from "date-fns";
//
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import PersonIcon from "@mui/icons-material/Person";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";

//
import { useSelector } from "react-redux";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { ToastErro } from "../utils/utils";
// Componente Dialog para outros tipos de conteudo
const DialogExibicao = ({ verDialogo, fecharDialogo, corpo }) => {
  return (
    <Dialog open={Boolean(verDialogo)}>
      <DialogContent>{corpo}</DialogContent>
      <DialogActions>
        <Button startIcon={<CloseIcon />} onClick={fecharDialogo}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
// Componente para exibir o Drawer de exibicao. Para mobile
const DrawerExibicao = ({ fecharDrawer, corpo }) => {
  return (
    <Drawer anchor="bottom" open={Boolean(corpo)} onClose={fecharDrawer}>
      {corpo}
    </Drawer>
  );
};

const ConfiguracoesDoUsuario = () => {
  // Veja se estamos em um mobile ou nao
  const {
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["md"] > window.innerWidth;
  //
  const [verDialogo, setVerDialogo] = useState(null);
  // Carregando as configurações do usuario
  const { usuario } = useSelector((state) => state);
  // Funcao para fechar o dialog
  const fecharDialogo = () => {
    setVerDialogo(null);
  };
  // Determina qual deve ser o dialogo a ser exibido
  let corpo;
  if (verDialogo === "senha") {
    corpo = <FormularioAlterarSenha fecharDialogo={fecharDialogo} />;
  } else if (verDialogo === "verImagem") {
    const { avatares, tamanhos } = usuario;
    let sx,
      tamanhoDefinido = isMobile ? window.innerWidth / 1.5 : 540;
    // Se a imagem for maior na largura ele que deve ser representada como imagem maximizada
    if (tamanhos["G"].width > tamanhos["G"].height) {
      sx = {
        width:
          tamanhos["G"].width > tamanhoDefinido
            ? tamanhoDefinido
            : tamanhos["G"].width,
      };
    } else {
      // Senao deve-se representar na altura
      sx = {
        height:
          tamanhos["G"].height > tamanhoDefinido
            ? tamanhoDefinido
            : tamanhos["G"].height,
      };
    }

    corpo = <img alt="Imagem de avatar" src={avatares["M"]} {...sx} />;
  }

  return (
    <Paper sx={{ mt: 1 }} elevation={0}>
      <ToastContainer position="bottom-center" />
      {isMobile && verDialogo !== "verImagem" ? (
        <DrawerExibicao corpo={corpo} fecharDrawer={fecharDialogo} />
      ) : (
        <DialogExibicao
          verDialogo={verDialogo}
          corpo={corpo}
          fecharDialogo={fecharDialogo}
        />
      )}
      <Container maxWidth="lg">
        <Typography align="center" variant="h6">
          Configurações do usuário
        </Typography>
        <Grid container>
          <Grid item xs={12} md={4}>
            {usuario && (
              <InformacoesUsuario
                usuario={usuario}
                fnExibirDialogo={setVerDialogo}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </Paper>
  );
};
// Componente que exibe as informações do usuario logado
const InformacoesUsuario = ({ usuario, fnExibirDialogo }) => {
  const refFoto = useRef(null);
  // Lista com as opcoes para descrever o botao
  const listaBotoes = [
    {
      nome: "Avatar",
      onClick: () => {
        refFoto.current.click();
        //fnExibirDialogo('avatar');
      },
      titulo: "Clique para alterar o avatar",
      icone: <PhotoCameraIcon />,
      desabilitado: false,
    },
    {
      nome: "Nome",
      onClick: () => {
        fnExibirDialogo("nome");
      },
      titulo: "Clique para alterar o nome",
      icone: <PersonIcon />,
      desabilitado: true,
    },
    {
      nome: "Senha",
      onClick: () => {
        fnExibirDialogo("senha");
      },
      titulo: "Clique para alterar a senha",
      icone: <VpnKeyIcon />,
      desabilitado: false,
    },
  ];
  // Cria uma funcao de callback para manipular uma solicitação de alteração de foto
  const fnAlterarImagem = (e) => {
    if (e.target.files.length > 0) {
      const ID_TOAST = toast.dark("Aguarde estamos enviando a imagem", {
        position: "top-center",
        type: "info",
      });
      // Vamos enviar o avatar para atualização
      const formData = new FormData();
      formData.append("arquivo", e.target.files[0]);
      // Agora envia para atualizar o avatar
      axios
        .post("/alterar_avatar", formData)
        .then((resp) => {
          // Fechar o toast
          toast.dismiss(ID_TOAST);

          if (resp.status !== 200) {
            toast.dark(
              "Erro interno no servidor, se persistir informar o admin",
              {
                type: "error",
              }
            );
            return false;
          }
          // Veriifca se tem alguma mensagem de erro
          if (resp.data.erro) {
            toast.dark(resp.data.erro, {
              type: "error",
            });
            return false;
          }
          // Tudo correto exibe mensagem de sucesso e atualiza a pagina
          toast.dark(resp.data.sucesso, {
            type: "success",
          });
          // Recarregando a pagina novamente
          setTimeout(() => {
            window.location.reload();
          }, 4000);
        })
        .catch((err) => {
          toast.error("Erro não reconhecido.");
        })
        .finally(() => {});

      //console.log(e.target.files.length);
    }
  };

  return (
    <Paper elevation={3} sx={{ mt: 2, p: 2, height: 250 }}>
      <input
        ref={refFoto}
        style={{ display: "none" }}
        type="file"
        onChange={fnAlterarImagem}
      />
      <Stack sx={{ height: "100%" }} justifyContent="space-between">
        <Stack>
          <Stack direction="row" alignItems="center">
            <Avatar
              onClick={() => fnExibirDialogo("verImagem")}
              src={usuario.avatar}
            />
            <Stack>
              <Stack direction="row" alignItems="center">
                <Typography
                  sx={{ ml: 1 }}
                  fontWeight="bold"
                  variant="subtitle2"
                >
                  Nome:
                </Typography>
                <Typography sx={{ ml: 1 }} variant="caption">
                  {usuario.nome}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center">
                <Typography
                  sx={{ ml: 1 }}
                  fontWeight="bold"
                  variant="subtitle2"
                >
                  E-mail:
                </Typography>
                <Typography sx={{ ml: 1 }} variant="caption">
                  {usuario.email}
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center">
                <Typography
                  sx={{ ml: 1 }}
                  fontWeight="bold"
                  variant="subtitle2"
                >
                  Admin:
                </Typography>
                <Typography sx={{ ml: 1 }} variant="caption">
                  {usuario.admin === "S" ? "SIM" : "NÃO"}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <Divider sx={{ my: 1 }} />
          <Stack direction="row" alignItems="center">
            <Typography sx={{ ml: 1 }} fontWeight="bold" variant="subtitle2">
              Último Login:
            </Typography>
            <Typography sx={{ ml: 1 }} variant="body2">
              {format(parseISO(usuario.ultimo_acesso), "dd/MM/yy HH:mm:ss")}
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          {listaBotoes.map((ele, idx) => (
            <BotaoInterface
              key={idx}
              titulo={ele.titulo}
              nome={ele.nome}
              icone={ele.icone}
              onClick={ele.onClick}
              desabilitado={ele.desabilitado}
            />
          ))}
        </Stack>
      </Stack>
    </Paper>
  );
};
// Componente que gera o botao abaixo
const BotaoInterface = ({ desabilitado, titulo, icone, nome, onClick }) => {
  return (
    <Button
      disabled={desabilitado}
      size="small"
      variant="outlined"
      title={titulo}
      onClick={onClick}
      startIcon={icone}
    >
      {nome}
    </Button>
  );
};
// Criar um schema para validacao dos campos de senha na interface
const schemaValidarSenha = yup.object().shape({
  senha: yup.string().min(6).required(),
  confirmarSenha: yup.string().min(6).required(),
});
// Este componente exibe um formulario para se alterar a senha
const FormularioAlterarSenha = ({ fecharDialogo }) => {
  // Controla o estado para aguardar
  const [aguardar, setAguardar] = useState(false);
  const [erro, setErro] = useState(null);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaValidarSenha),
  });

  // Funcao para manipular os campos de senha
  const fn = (val) => {
    setErro(null);

    const { senha, confirmarSenha } = val;
    // Se as senhas forem diferentes exiba uma mensagem de erro
    if (senha !== confirmarSenha) {
      setErro("As senhas são diferentes");
      return false;
    }
    // Agora envie as senhas para que possamos fazer a atualização
    const formData = {
      senha,
      repetir_senha: confirmarSenha,
    };
    //
    setAguardar(true);

    axios
      .post("/alterar_senha_usuario", formData)
      .then((resp) => {
        // Se tudo tiver dado certo
        toast.success(resp.data.sucesso);
        //
        if (fecharDialogo) fecharDialogo();
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ToastErro(err.response.data.message);
        } else {
          ToastErro(String(err));
        }
      })
      .finally(() => {
        setAguardar(false);
      });
  };

  return (
    <Container sx={{ px: 1, py: 2 }} maxWidth="md">
      <Stack>
        <Typography variant="h6" align="center">
          Alteração de senha
        </Typography>

        <Typography variant="caption" align="center">
          Defina uma nova senha e depois a confirme digitando a mesma senha
          abaixo.
        </Typography>

        <Divider sx={{ my: 1 }} />
        <Controller
          name="senha"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              type="password"
              fullWidth
              size="small"
              sx={{ my: 2 }}
              InputLabelProps={{ shrink: true }}
              InputProps={{ autoComplete: "disabled" }}
              label="Senha"
              placeholder="Digite a senha"
              helperText={errors.senha && "Minimo de 6 caracteres"}
              error={!!errors.senha}
            />
          )}
        />
        <Controller
          name="confirmarSenha"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              sx={{ my: 2 }}
              InputLabelProps={{ shrink: true }}
              type="password"
              size="small"
              InputProps={{ autoComplete: "disabled" }}
              fullWidth
              label="Confirmar Senha"
              placeholder="Digite a senha de confirmação"
              helperText={errors.confirmarSenha && "Minimo de 6 caracteres"}
              error={!!errors.confirmarSenha}
            />
          )}
        />
        {erro && (
          <Typography
            sx={{ my: 1 }}
            variant="body2"
            align="center"
            color="error"
          >
            {erro}
          </Typography>
        )}
        <Button
          variant="contained"
          onClick={handleSubmit(fn)}
          startIcon={aguardar ? <CircularProgress size={20} /> : <SaveIcon />}
          title="Alterar senha"
        >
          ENVIAR
        </Button>
      </Stack>
    </Container>
  );
};

export default ConfiguracoesDoUsuario;
